function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexagonFront({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "100,10 190,50 190,150 100,190 10,150 10,50",
    style: {
      fill: "#1f252b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonFront);
export default __webpack_public_path__ + "static/media/hexagonFront.68dd8c5679c6141b4ab7659bb865da0a.svg";
export { ForwardRef as ReactComponent };